import React from 'react';

import Card from '../../Card';
import Button from '../../form/Button';
import './no-files.css';

const NoFiles = ({ clearFilters }) => {
	return (
		<Card title="No Files" color="tertiary" titleHighlight={true} className="no-files__card">
			<p>There are no files, please Clear Filters</p>
			{clearFilters && 
				<Button onClick={clearFilters} color="secondary">
					Clear Filters
				</Button>
			}
		</Card>
	);
};

export default NoFiles;


// WEBPACK FOOTER //
// ./src/components/common/files/NoFiles/index.js